import { getAccountKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import { copilotUpsellStore } from "../store/copilotUpsellStore";

export function getCopilotUpsellEligibility(mailboxInfo: MailboxInfo): boolean {
    return (copilotUpsellStore().eligibilityByAccount.get(getAccountKeyForMailboxInfo(mailboxInfo)) ??
        false);
}
